<template>
  <div class="body">
    <div class="plate_title">
      <div class="plate_title_name">新箱图分类</div>
    </div>
    <div class="bb p30">
      <div class="head flex fw_w">
        <div>
          <div>研究员</div>
          <div class="w300">
            <el-select
              v-model="user_id"
              class="m-2"
              placeholder="请选择研究员"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div>
          <el-button @click="search" type="primary">搜 索</el-button>
        </div>
      </div>
      <div class="mb20">
        <el-button type="primary" @click="handleFormShow()">添加分类</el-button>
      </div>
      <!-- 数据列表 -->
      <div v-loading="listLoading">
        <el-table :data="categoryList" height="70vh" style="width: 100%">
          <el-table-column label="ID" width="120" prop="id"> </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分类名称"
            width="200"
            prop="name"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="研究员"
            width="200"
            prop="user.username"
          >
          </el-table-column>
          <el-table-column label="排序(越大越靠前)" width="160" prop="weigh">
          </el-table-column>
          <el-table-column label="开关" width="100" align="center">
            <template #default="scope">
              <el-switch
                @change="(e) => changeSwitch(e, scope.$index)"
                v-model="scope.row.switch"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300" align="center">
            <template #default="scope">
              <el-button
                type="primary"
                size="default"
                @click="handleFormShow(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="default"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 弹出表单 -->
    <el-dialog width="500px" v-model="formShow" :title="formTitle">
      <div class="flex">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="研究员">
            <el-select
              v-model="form.user_id"
              class="m-2"
              placeholder="请选择研究员"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input v-model="form.weigh"></el-input>
          </el-form-item>
          <el-form-item label="开关">
            <el-switch
              v-model="form.switch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      list: [],
      name: "", // 分类名称检索条件
      formShow: false,
      formTitle: "",
      form: {
        id: null,
        user_id: null,
        name: "", // 分类名称
        weigh: 0,
        switch: 1,
      }, // 提交表单信息

      user_id: null, // 研究员id
      teacherList: [],
    };
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    this.getTeacherList();
    this.getList();
  },
  methods: {
    onmessage(e) {},
    search() {
      this.list = [];
      this.getList();
    },
    async getTeacherList() {
      const res = await request.post("/teacher/douyin_image/getTeacherList");
      this.teacherList = res.data;
    },
    // 获取分类列表
    async getList() {
      this.listLoading = true;
      const res = await request.post("/teacher/douyin_image/getCategoryList", {
        user_id: this.user_id,
      });
      this.categoryList = res.data;
      this.listLoading = false;
    },
    async onSubmit() {
      var form = this.form;
      var obj = { ...form };
      if (!obj.user_id) {
        this.$message.error("请选择研究员");
        return false;
      }
      if (!obj.name) {
        this.$message.error("请填写分类名称");
        return false;
      }

      var res = null;
      if (obj.id) {
        res = await request.post("/teacher/douyin_image/editCategory", obj);
      } else {
        res = await request.post("/teacher/douyin_image/addCategory", obj);
      }
      this.$message.success(res.msg);
      this.formShow = false;
      this.getList();
    },
    handleFormShow(e) {
      if (e != undefined) {
        // 修改
        this.formTitle = "修改";
        this.form.id = e.id;
        this.form.user_id = e.user_id;
        this.form.name = e.name;
        this.form.weigh = e.weigh;
        this.form.switch = e.switch;
      } else {
        // 添加
        this.formTitle = "添加";
        this.form.id = null;
        this.form.user_id = null;
        this.form.name = "";
        this.form.weigh = 0;
        this.form.switch = 1;
      }
      this.formShow = true;
    },
    handleDelete(index, row) {
      this.$confirm("确认删除该数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteApi(index, row);
      });
    },
    async handleDeleteApi(index, row) {
      const res = await request.post("/teacher/douyin_image/delCategory", {
        id: row.id,
      });
      this.$message.success(res.msg);
      this.getList();
    },
    changeSwitch(e, index) {
      const categoryList = this.categoryList;
      this.form.id = categoryList[index].id;
      this.form.user_id = categoryList[index].user_id;
      this.form.name = categoryList[index].name;
      this.form.weigh = categoryList[index].weigh;
      this.form.switch = e;
      this.onSubmit();
    },
  },
};
</script>

<style scoped>
.body {
  height: 100vh;
}

.plate_title {
  background-color: #f8fcff;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 18px 0;
  border-top: 1px solid #ebeced;
  border-bottom: 1px solid #ebeced;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plate_title_name {
  position: relative;
  line-height: 16px;
  padding-left: 30px;
}

.plate_title_name::before {
  content: "";
  position: absolute;
  left: 13px;
  width: 4px;
  height: 16px;
  background-color: #5389f5;
  border-radius: 5px;
}

.head > div {
  margin: 0 30px 20px 0;
  display: flex;
  align-items: center;
}

.head > div > div:first-child {
  margin-right: 10px;
  /* margin-bottom: 10px; */
}

.el-form {
  width: 90%;
}

.icon_del {
  display: block;
  width: 26px;
  height: 26px;
  margin-left: 10px;
}
</style>
